const HomeApi = {
  checkStatus: '/check/status', // 获取购买状态
  cartAddNormal: '/cart/add/normal', // 加入购物车
  asyncGroupValidatePerfect: '/async/group/validate/perfect', // 购买立推
  indexTopBanner: `/advertising/index/top/banners`, // 横幅
  indexCarouselBanner: `/advertising/index/carousel/banner`, // 轮播
};

export default HomeApi;
